import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import CssBaseline from "@mui/material/CssBaseline";
import { Slide, ToastContainer } from "react-toastify";
import {useThemeStore} from "./store/useThemeStore";
import "./App.scss";
import Routes from "./Routes";
import { BrowserRouter } from 'react-router';



function App() {
    const { themeOptions } = useThemeStore();
    const theme = createTheme(themeOptions);
  return (
      <ThemeProvider theme={theme}>
          <ToastContainer position="top-right" transition={Slide} newestOnTop autoClose={7000} />
          <CssBaseline />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <BrowserRouter>
              <Routes />
            </BrowserRouter>
          </LocalizationProvider>
      </ThemeProvider>
  );
}

export default App;
